<template>
    <div id="two" class="TwoColsItemsBlock two mt-8 pb-3 md:pt-16 lg:pt-28">
        <div class="container">
            <CHeading class="text-center" section variant="2">
                <slot />
            </CHeading>

            <div class="items mt-8 grid gap-8 sm:grid-cols-2 sm:gap-12 md:mt-16 lg:mt-28 lg:gap-24">
                <div v-for="(item, index) in cols" :key="index" class="sm:pl-18">
                    <p class="relative ml-18 sm:ml-0">
                        <span
                            class="absolute left-[-5.5rem] top-0 h-full border-r-4 border-black/[.2] px-4 py-5 text-4xl font-semibold text-black/[.2]"
                            >{{ index + 1 }}</span
                        >
                        <img :alt="item.alt" class="mb-6 h-18" loading="lazy" :src="item.img" />
                        <span class="text-2xl font-semibold">
                            {{ item.title }}
                        </span>
                    </p>
                    <br />
                    <p v-if="item.text" class="mt-4 text-lg">
                        <span v-html="item.text"></span>
                    </p>
                    <div v-if="$slots.button && index === cols.length - 1">
                        <slot name="button" />
                    </div>
                </div>
            </div>

            <div v-if="$slots.bottom" class="text-center">
                <slot name="bottom" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'

import CHeading from '@/components/ui/CHeading.vue'

export interface TwoColsItem {
    img: string
    alt: string
    title: string
    text: string
}

export type TwoColsItemsBlockType = TwoColsItem[]

defineProps({
    cols: {
        type: Array as PropType<TwoColsItemsBlockType>,
        required: true
    }
})
</script>
